import React from 'react';
import Dialog, { Content, DialogActions, Title } from 'ui/views/dialogs/Dialog';
import Button from 'ui/elements/buttons/Button';
import ButtonList from 'ui/elements/buttons/ButtonList';
import { useReLogin } from './useLoginWithRedirect';
import { useSessionExpired } from './SessionExpiredContext';

// Shown when the session dies while the app is open. The app stays mounted behind it, so "Not now"
// lets the user copy out anything unsaved before logging in again. It can't be a snackbar, since
// NotificationContext caps those at 10 seconds.
export default function SessionExpiredDialog() {
  const { isSessionExpired, clearSessionExpired } = useSessionExpired();
  const reLogin = useReLogin();

  return (
    <Dialog open={isSessionExpired} onClose={clearSessionExpired} maxWidth="xs">
      <Title onClose={clearSessionExpired}>You've been logged out</Title>
      <Content>
        <p className="text-body">
          Your session has expired. Log in again to continue. Anything you haven't saved will be lost.
        </p>
      </Content>
      <DialogActions>
        <ButtonList align="right">
          <Button kind="tertiary" onClick={clearSessionExpired}>
            Not now
          </Button>
          <Button kind="primary" autoFocus onClick={reLogin}>
            Log in again
          </Button>
        </ButtonList>
      </DialogActions>
    </Dialog>
  );
}
